const symbols = {
  "symbols": [
    {
      "ric": "AEML_tk.SI",
      "name": "AEM MB eCW210302",
      "security_code": "983W"
    },
    {
      "ric": "AEML_tm.SI",
      "name": "AEM MB eCW210917",
      "security_code": "VKEW"
    },
    {
      "ric": "ALML_th.SI",
      "name": "Alibaba MB eCW210705",
      "security_code": "R42W"
    },
    {
      "ric": "ALML_tg.SI",
      "name": "Alibaba MB ePW210705",
      "security_code": "QBDW"
    },
    {
      "ric": "ALML_tf.SI",
      "name": "AlibabaMBeCW210405",
      "security_code": "1M7W"
    },
    {
      "ric": "ALML_te.SI",
      "name": "AlibabaMBePW210405",
      "security_code": "X7RW"
    },
    {
      "ric": "AEML_tj.SI",
      "name": "AscendasReit MBeCW210302",
      "security_code": "WQ6W"
    },
    {
      "ric": "AEML_tl.SI",
      "name": "AscendasReit MBeCW210524",
      "security_code": "RQOW"
    },
    {
      "ric": "BYML_td.SI",
      "name": "BYD MB eCW210302",
      "security_code": "XATW"
    },
    {
      "ric": "BYML_tb.SI",
      "name": "BYD MB eCW210405",
      "security_code": "VHUW"
    },
    {
      "ric": "BYML_te.SI",
      "name": "BYD MB eCW210705",
      "security_code": "TMHW"
    },
    {
      "ric": "BYML_tg.SI",
      "name": "BYD MB eCW210705A",
      "security_code": "MGVW"
    },
    {
      "ric": "BYML_tc.SI",
      "name": "BYD MB ePW210302",
      "security_code": "NYBW"
    },
    {
      "ric": "BYML_ta.SI",
      "name": "BYD MB ePW210405",
      "security_code": "RUQW"
    },
    {
      "ric": "BYML_tf.SI",
      "name": "BYD MB ePW210705",
      "security_code": "YBMW"
    },
    {
      "ric": "BYML_th.SI",
      "name": "BYD MB ePW210705A",
      "security_code": "VRJW"
    },
    {
      "ric": "CAML_t2.SI",
      "name": "CapitalaMBeCW210222",
      "security_code": "WU1W"
    },
    {
      "ric": "CAML_t3.SI",
      "name": "CapitalaMBeCW210304",
      "security_code": "HUFW"
    },
    {
      "ric": "CAML_t4.SI",
      "name": "CapitalaMBeCW211018",
      "security_code": "MHJW"
    },
    {
      "ric": "CTML_tt.SI",
      "name": "CityDev MB eCW210507",
      "security_code": "LQXW"
    },
    {
      "ric": "CMML_t1.SI",
      "name": "ComfortDel MBeCW210301",
      "security_code": "XLJW"
    },
    {
      "ric": "CMML_t2.SI",
      "name": "ComfortDel MBeCW211018",
      "security_code": "MSHW"
    },
    {
      "ric": "DBML_t30.SI",
      "name": "DBS MB eCW210405",
      "security_code": "WRAW"
    },
    {
      "ric": "DBML_t31.SI",
      "name": "DBS MB eCW210407",
      "security_code": "EYOW"
    },
    {
      "ric": "DBML_t38.SI",
      "name": "DBS MB eCW210503",
      "security_code": "HRZW"
    },
    {
      "ric": "DBML_t33.SI",
      "name": "DBS MB eCW211001",
      "security_code": "9WJW"
    },
    {
      "ric": "DBML_t34.SI",
      "name": "DBS MB eCW211008",
      "security_code": "OFHW"
    },
    {
      "ric": "DBML_t29.SI",
      "name": "DBS MB ePW210217",
      "security_code": "XPUW"
    },
    {
      "ric": "DBML_t32.SI",
      "name": "DBS MB ePW210701",
      "security_code": "YY9W"
    },
    {
      "ric": "DBML_t37.SI",
      "name": "DBS MB ePW210705",
      "security_code": "QYLW"
    },
    {
      "ric": "DBML_t36.SI",
      "name": "DBS MB ePW211001",
      "security_code": "KEDW"
    },
    {
      "ric": "DBML_t35.SI",
      "name": "DBS MB ePW211008",
      "security_code": "RWXW"
    },
    {
      "ric": "GEML_tb.SI",
      "name": "Geely MB eCW210405",
      "security_code": "RQUW"
    },
    {
      "ric": "GEML_td.SI",
      "name": "Geely MB eCW210705",
      "security_code": "RUHW"
    },
    {
      "ric": "GEML_te.SI",
      "name": "Geely MB eCW211005",
      "security_code": "XQDW"
    },
    {
      "ric": "GEML_ta.SI",
      "name": "Geely MB ePW210405",
      "security_code": "XZ4W"
    },
    {
      "ric": "GEML_tc.SI",
      "name": "Geely MB ePW210705",
      "security_code": "OCCW"
    },
    {
      "ric": "GEML_tf.SI",
      "name": "Geely MB ePW211005",
      "security_code": "VZGW"
    },
    {
      "ric": "GTML_te.SI",
      "name": "GentingSMBeCW210701",
      "security_code": "XJLW"
    },
    {
      "ric": "HSML_t210.SI",
      "name": "HSI 24800MBePW210528",
      "security_code": "TPCW"
    },
    {
      "ric": "HSML_t189.SI",
      "name": "HSI 25000MBePW210225",
      "security_code": "VOIW"
    },
    {
      "ric": "HSML_t204.SI",
      "name": "HSI 25400MBePW210429",
      "security_code": "FMPW"
    },
    {
      "ric": "HSML_t197.SI",
      "name": "HSI 25800MBePW210330",
      "security_code": "KWBW"
    },
    {
      "ric": "HSML_t191.SI",
      "name": "HSI 26000MBePW210225",
      "security_code": "JXBW"
    },
    {
      "ric": "HSML_t205.SI",
      "name": "HSI 26200MBePW210429",
      "security_code": "TNSW"
    },
    {
      "ric": "HSML_t214.SI",
      "name": "HSI 26400MBePW210528",
      "security_code": "EGAW"
    },
    {
      "ric": "HSML_t193.SI",
      "name": "HSI 26600MBeCW210225",
      "security_code": "UCEW"
    },
    {
      "ric": "HSML_t209.SI",
      "name": "HSI 26600MBeCW210528",
      "security_code": "OKCW"
    },
    {
      "ric": "HSML_t196.SI",
      "name": "HSI 26600MBePW210330",
      "security_code": "NMKW"
    },
    {
      "ric": "HSML_t199.SI",
      "name": "HSI 27000MBePW210429",
      "security_code": "8XWW"
    },
    {
      "ric": "HSML_t195.SI",
      "name": "HSI 27200MBeCW210330",
      "security_code": "W6JW"
    },
    {
      "ric": "HSML_t192.SI",
      "name": "HSI 27400MBeCW210225",
      "security_code": "FCHW"
    },
    {
      "ric": "HSML_t208.SI",
      "name": "HSI 27400MBePW210330",
      "security_code": "EEKW"
    },
    {
      "ric": "HSML_t200.SI",
      "name": "HSI 27600MBeCW210429",
      "security_code": "GJDW"
    },
    {
      "ric": "HSML_t194.SI",
      "name": "HSI 28000MBeCW210330",
      "security_code": "OMCW"
    },
    {
      "ric": "HSML_t207.SI",
      "name": "HSI 28000MBePW210528",
      "security_code": "1HZW"
    },
    {
      "ric": "HSML_t190.SI",
      "name": "HSI 28200MBeCW210225",
      "security_code": "8Y4W"
    },
    {
      "ric": "HSML_t213.SI",
      "name": "HSI 28200MBePW210330",
      "security_code": "9PCW"
    },
    {
      "ric": "HSML_t201.SI",
      "name": "HSI 28400MBeCW210429",
      "security_code": "SGAW"
    },
    {
      "ric": "HSML_t206.SI",
      "name": "HSI 28600MBePW210429",
      "security_code": "CVCW"
    },
    {
      "ric": "HSML_t198.SI",
      "name": "HSI 28800MBeCW210330",
      "security_code": "QHEW"
    },
    {
      "ric": "HSML_t202.SI",
      "name": "HSI 29200MBeCW210429",
      "security_code": "DZBW"
    },
    {
      "ric": "HSML_t215.SI",
      "name": "HSI 29600MBeCW210330",
      "security_code": "5N8W"
    },
    {
      "ric": "HSML_t203.SI",
      "name": "HSI 30000MBeCW210429",
      "security_code": "XLDW"
    },
    {
      "ric": "HSML_t212.SI",
      "name": "HSI 30400MBeCW210330",
      "security_code": "HGKW"
    },
    {
      "ric": "HSML_t216.SI",
      "name": "HSI 30800MBeCW210429",
      "security_code": "X5OW"
    },
    {
      "ric": "HSML_t211.SI",
      "name": "HSI 31200MBeCW210528",
      "security_code": "Z7PW"
    },
    {
      "ric": "IFML_tu.SI",
      "name": "IFAST MB eCW210601",
      "security_code": "KTRW"
    },
    {
      "ric": "JDML_tb.SI",
      "name": "JD MB eCW210705",
      "security_code": "OPSW"
    },
    {
      "ric": "JDML_tc.SI",
      "name": "JD MB ePW210705",
      "security_code": "DVDW"
    },
    {
      "ric": "KPML_t8.SI",
      "name": "KepCorp MBeCW210222",
      "security_code": "SJOW"
    },
    {
      "ric": "KPML_t9.SI",
      "name": "KepCorpMBeCW210304",
      "security_code": "NMBW"
    },
    {
      "ric": "KPML_t10.SI",
      "name": "KepCorpMBeCW211018",
      "security_code": "WFEW"
    },
    {
      "ric": "MCML_ta.SI",
      "name": "MapleComTr MB eCW210302",
      "security_code": "9EFW"
    },
    {
      "ric": "MAML_t.SI",
      "name": "MapleComTr MB eCW211018",
      "security_code": "TRGW"
    },
    {
      "ric": "MEML_tb.SI",
      "name": "Meituan MB eCW210405",
      "security_code": "JAOW"
    },
    {
      "ric": "MEML_td.SI",
      "name": "Meituan MB eCW210705",
      "security_code": "YC8W"
    },
    {
      "ric": "MEML_ta.SI",
      "name": "Meituan MB ePW210405",
      "security_code": "YLAW"
    },
    {
      "ric": "MEML_tc.SI",
      "name": "Meituan MB ePW210705",
      "security_code": "MXTW"
    },
    {
      "ric": "NIML_t20.SI",
      "name": "NKY 19000MBePW210312",
      "security_code": "WG8W"
    },
    {
      "ric": "NIML_t27.SI",
      "name": "NKY 20000MBePW210611",
      "security_code": "HASW"
    },
    {
      "ric": "NIML_t19.SI",
      "name": "NKY 22000MBePW210312",
      "security_code": "UAFW"
    },
    {
      "ric": "NIML_t28.SI",
      "name": "NKY 23000MBePW210611",
      "security_code": "XDQW"
    },
    {
      "ric": "NIML_t16.SI",
      "name": "NKY 24000MBeCW210312",
      "security_code": "PJLW"
    },
    {
      "ric": "NIML_t22.SI",
      "name": "NKY 25000MBeCW210611",
      "security_code": "ZALW"
    },
    {
      "ric": "NIML_t21.SI",
      "name": "NKY 25000MBePW210312",
      "security_code": "VTWW"
    },
    {
      "ric": "NIML_t23.SI",
      "name": "NKY 26000MBePW210611",
      "security_code": "EOGW"
    },
    {
      "ric": "NIML_t17.SI",
      "name": "NKY 27000MBeCW210312",
      "security_code": "FIQW"
    },
    {
      "ric": "NIML_t24.SI",
      "name": "NKY 28000MBeCW210611",
      "security_code": "TCFW"
    },
    {
      "ric": "NIML_t25.SI",
      "name": "NKY 29000MBePW210611",
      "security_code": "9AFW"
    },
    {
      "ric": "NIML_t18.SI",
      "name": "NKY 30000MBeCW210312",
      "security_code": "YTXW"
    },
    {
      "ric": "NIML_t26.SI",
      "name": "NKY 31000MBeCW210611",
      "security_code": "LXLW"
    },
    {
      "ric": "OCML_t11.SI",
      "name": "OCBC Bk MB eCW210301",
      "security_code": "XV1W"
    },
    {
      "ric": "OCML_t18.SI",
      "name": "OCBC Bk MB eCW210303",
      "security_code": "JSYW"
    },
    {
      "ric": "OCML_t27.SI",
      "name": "OCBC Bk MB eCW210507",
      "security_code": "ZRDW"
    },
    {
      "ric": "OCML_t20.SI",
      "name": "OCBC Bk MB eCW210510",
      "security_code": "LQFW"
    },
    {
      "ric": "OCML_t22.SI",
      "name": "OCBC Bk MB eCW210514",
      "security_code": "GWWW"
    },
    {
      "ric": "OCML_t25.SI",
      "name": "OCBC Bk MB eCW211112",
      "security_code": "WZ1W"
    },
    {
      "ric": "OCML_t23.SI",
      "name": "OCBC Bk MB eCW211115",
      "security_code": "VYWW"
    },
    {
      "ric": "OCML_t17.SI",
      "name": "OCBC Bk MB ePW210217",
      "security_code": "IEIW"
    },
    {
      "ric": "OCML_t19.SI",
      "name": "OCBC Bk MB ePW210701",
      "security_code": "EUEW"
    },
    {
      "ric": "OCML_t21.SI",
      "name": "OCBC Bk MB ePW210705",
      "security_code": "9I5W"
    },
    {
      "ric": "OCML_t24.SI",
      "name": "OCBC Bk MB ePW211112",
      "security_code": "95JW"
    },
    {
      "ric": "OCML_t26.SI",
      "name": "OCBC Bk MB ePW211115",
      "security_code": "JWRW"
    },
    {
      "ric": "SXML_t20.SI",
      "name": "S&P 2700MBePW210319",
      "security_code": "IQZW"
    },
    {
      "ric": "SXML_t22.SI",
      "name": "S&P 2950MBePW210319",
      "security_code": "DOHW"
    },
    {
      "ric": "SXML_t24.SI",
      "name": "S&P 3000MBePW210618",
      "security_code": "XYPW"
    },
    {
      "ric": "SXML_t23.SI",
      "name": "S&P 3400MBePW210618",
      "security_code": "OKBW"
    },
    {
      "ric": "SXML_t26.SI",
      "name": "S&P 3800MBeCW210618",
      "security_code": "RUUW"
    },
    {
      "ric": "SXML_t21.SI",
      "name": "S&P 3950MBeCW210319",
      "security_code": "VQEW"
    },
    {
      "ric": "SXML_t25.SI",
      "name": "S&P 4200MBeCW210618",
      "security_code": "GTJW"
    },
    {
      "ric": "SNML_t2.SI",
      "name": "SGX MB eCW210315",
      "security_code": "9QJW"
    },
    {
      "ric": "SNML_t4.SI",
      "name": "SGX MB eCW211018",
      "security_code": "ESYW"
    },
    {
      "ric": "SNML_t1.SI",
      "name": "SGX MB ePW210315",
      "security_code": "RXPW"
    },
    {
      "ric": "SNML_t3.SI",
      "name": "SGX MB ePW211018",
      "security_code": "UJGW"
    },
    {
      "ric": "SLML_ta.SI",
      "name": "SIA MB eCW210701",
      "security_code": "GIJW"
    },
    {
      "ric": "SEML_t17.SI",
      "name": "SingtelMBeCW210222",
      "security_code": "YX7W"
    },
    {
      "ric": "SEML_t18.SI",
      "name": "SingtelMBeCW210304",
      "security_code": "GJAW"
    },
    {
      "ric": "SEML_t16.SI",
      "name": "SingtelMBeCW210331",
      "security_code": "YBNW"
    },
    {
      "ric": "SEML_t7.SI",
      "name": "SingtelMBeCW211018",
      "security_code": "59XW"
    },
    {
      "ric": "STML_t31.SI",
      "name": "STI 2300MBePW210331",
      "security_code": "WVEW"
    },
    {
      "ric": "STML_t35.SI",
      "name": "STI 2400MBePW210630",
      "security_code": "OSTW"
    },
    {
      "ric": "STML_t32.SI",
      "name": "STI 2500MBePW210331",
      "security_code": "DFAW"
    },
    {
      "ric": "STML_t42.SI",
      "name": "STI 2500MBePW210930",
      "security_code": "JUUW"
    },
    {
      "ric": "STML_t33.SI",
      "name": "STI 2550MBeCW210331",
      "security_code": "8C5W"
    },
    {
      "ric": "STML_t39.SI",
      "name": "STI 2600MBePW210630",
      "security_code": "VVZW"
    },
    {
      "ric": "STML_t34.SI",
      "name": "STI 2650MBeCW210630",
      "security_code": "XINW"
    },
    {
      "ric": "STML_t41.SI",
      "name": "STI 2750MBePW210930",
      "security_code": "JUPW"
    },
    {
      "ric": "STML_t29.SI",
      "name": "STI 2800MBeCW210331",
      "security_code": "URDW"
    },
    {
      "ric": "STML_t40.SI",
      "name": "STI 2800MBeCW210930",
      "security_code": "UNCW"
    },
    {
      "ric": "STML_t36.SI",
      "name": "STI 2800MBePW210630",
      "security_code": "YZHW"
    },
    {
      "ric": "STML_t37.SI",
      "name": "STI 2900MBeCW210630",
      "security_code": "PXKW"
    },
    {
      "ric": "STML_t30.SI",
      "name": "STI 3000MBeCW210331",
      "security_code": "VSBW"
    },
    {
      "ric": "STML_t45.SI",
      "name": "STI 3000MBePW210930",
      "security_code": "PCEW"
    },
    {
      "ric": "STML_t44.SI",
      "name": "STI 3050MBeCW210930",
      "security_code": "V6OW"
    },
    {
      "ric": "STML_t38.SI",
      "name": "STI 3100MBeCW210630",
      "security_code": "EZEW"
    },
    {
      "ric": "STML_t43.SI",
      "name": "STI 3300MBeCW210930",
      "security_code": "LZTW"
    },
    {
      "ric": "SUML_tb.SI",
      "name": "Sunny MB eCW210405",
      "security_code": "9T9W"
    },
    {
      "ric": "SUML_tc.SI",
      "name": "Sunny MB eCW210705",
      "security_code": "WAVW"
    },
    {
      "ric": "SUML_ta.SI",
      "name": "Sunny MB ePW210405",
      "security_code": "PDGW"
    },
    {
      "ric": "SUML_td.SI",
      "name": "Sunny MB ePW210705",
      "security_code": "8P7W"
    },
    {
      "ric": "TCML_t17.SI",
      "name": "TencentMBeCW210302",
      "security_code": "Q31W"
    },
    {
      "ric": "TCML_t20.SI",
      "name": "TencentMBeCW210705",
      "security_code": "PHDW"
    },
    {
      "ric": "TCML_t18.SI",
      "name": "TencentMBePW210302",
      "security_code": "WL7W"
    },
    {
      "ric": "TCML_t19.SI",
      "name": "TencentMBePW210705",
      "security_code": "WVDW"
    },
    {
      "ric": "TOML_tc.SI",
      "name": "Top Glove MB eCW210302",
      "security_code": "WHGW"
    },
    {
      "ric": "TOPG_ta.SI",
      "name": "Top Glove MB eCW210917",
      "security_code": "1P7W"
    },
    {
      "ric": "UOML_t24.SI",
      "name": "UOB MB eCW210405",
      "security_code": "SMOW"
    },
    {
      "ric": "UOML_t25.SI",
      "name": "UOB MB eCW210407",
      "security_code": "FSXW"
    },
    {
      "ric": "UOML_t35.SI",
      "name": "UOB MB eCW210503",
      "security_code": "V8DW"
    },
    {
      "ric": "UOML_t26.SI",
      "name": "UOB MB eCW210506",
      "security_code": "PWBW"
    },
    {
      "ric": "UOML_t34.SI",
      "name": "UOB MB eCW210514",
      "security_code": "ELVW"
    },
    {
      "ric": "UOML_t31.SI",
      "name": "UOB MB eCW211001",
      "security_code": "XIIW"
    },
    {
      "ric": "UOML_t28.SI",
      "name": "UOB MB eCW211004",
      "security_code": "KVKW"
    },
    {
      "ric": "UOML_t29.SI",
      "name": "UOB MB eCW211008",
      "security_code": "RABW"
    },
    {
      "ric": "UOML_t23.SI",
      "name": "UOB MB ePW210217",
      "security_code": "9KVW"
    },
    {
      "ric": "UOML_t27.SI",
      "name": "UOB MB ePW210701",
      "security_code": "X0RW"
    },
    {
      "ric": "UOML_t33.SI",
      "name": "UOB MB ePW210705",
      "security_code": "YWRW"
    },
    {
      "ric": "UOML_t32.SI",
      "name": "UOB MB ePW211001",
      "security_code": "VIFW"
    },
    {
      "ric": "UOML_t30.SI",
      "name": "UOB MB ePW211008",
      "security_code": "MPPW"
    },
    {
      "ric": "ULML_t.SI",
      "name": "UOL MB eCW210701",
      "security_code": "ORGW"
    },
    {
      "ric": "WLML_t8.SI",
      "name": "Wilmar MB eCW210222",
      "security_code": "NDHW"
    },
    {
      "ric": "WLML_t7.SI",
      "name": "Wilmar MB eCW210331",
      "security_code": "KSCW"
    },
    {
      "ric": "WLML_t9.SI",
      "name": "Wilmar MB eCW211018",
      "security_code": "NLGW"
    },
    {
      "ric": "XIML_t11.SI",
      "name": "XIAOMI MBeCW210405",
      "security_code": "FWDW"
    },
    {
      "ric": "XIML_t16.SI",
      "name": "XIAOMI MBeCW210705",
      "security_code": "WAIW"
    },
    {
      "ric": "XIML_t12.SI",
      "name": "XIAOMI MBePW210405",
      "security_code": "UDWW"
    },
    {
      "ric": "XIML_t15.SI",
      "name": "XIAOMI MBePW210705",
      "security_code": "UKKW"
    },
    {
      "ric": "YZML_tx.SI",
      "name": "YangzijiMBeCW211101",
      "security_code": "FOHW"
    }
  ]
}

const symbolsSimple = {
  "symbols": [
    {
      "ric": "AEML_tk.SI",
      "name": "AEM MB eCW210302",
      "security_code": "983W"
    }    
  ]
}

const AEML_tk = {
	"AEML_tk.SI": {
		"underlying_ric": "AEM.SI",
		"b_trbc_business": null,
		"theta": "-11.27",
		"LOLIMIT": "0",
		"TRDPRC_1": "0.011",
		"percent_moneyness": "3",
		"last_trading_date": "23 Feb 21",
		"HIGH_1": "0.068",
		"type": "CALL",
		"effective_gearing": "22.8",
		"conv_ratio": "10.0",
		"wrnt_per_share": "0.100",
		"BID_PCTCHNG_2DP": "-60.00",
		"LOW_1": "0.006",
		"30D_LOW": "-",
		"ticker": "983W",
		"breakeven_price": "4.56",
		"underlying_pctchng": "-1.81",
		"delta_per_wrnt": "3.153",
		"warrant_price": 0.006,
		"TURNOVER_SCALED": "0",
		"OPEN_PRC": "0.049",
		"NO_BIDMKR2": "-",
		"dsply_nmll": "AEM MB eCW210302",
		"issuer_name": "Macquarie Bank Ltd",
		"sensitivity": "3.17",
		"delta": "31.5",
		"TRADE_DATE": "22 Feb 21",
		"NO_BIDMKR2_SCALED": "-",
		"underlying_price_adj": 4.34,
		"BID_PCTCHNG": "-60.0",
		"BIDSIZE": "410,000",
		"underlying_price_cal": 4.35,
		"exercise_price_adj": 4.5,
		"update_time": "22 Feb 21 16:52",
		"dsply_name": "AEM MB eCW210302",
		"YRHIGH": "-",
		"BEST_BSIZ1": "410000",
		"HST_CLOSE": "0.015",
		"ACVOL_1_SCALED": "20",
		"BID": "0.006",
		"r_hst_close": 1,
		"maturity": "02 Mar 21",
		"div_yield": 1.963883,
		"underlying_bid": 4.34,
		"fmt": 1,
		"30D_HIGH": "-",
		"SYMBOL": "AEML_tk.SI",
		"HST_VOL_SCALED": "-",
		"underlying_price": "4.35",
		"list_date": "24 Sep 20",
		"underlying_curr": "SGD",
		"exchange_code": "SES",
		"ASK": "0.009",
		"currency": "SGD",
		"conv_ratio_cal": 10.0,
		"UPLIMIT": "0",
		"BID_NETCHNG": "-0.009",
		"NETCHNG_1": "-0.0",
		"HST_VOL": "-",
		"implied_volatility": "47.6",
		"VOL_PCTCHNG": "-",
		"TRDTIM_1": "07:03",
		"moneyness": "2",
		"ASKSIZE": "3,000,000",
		"premium": "4.8",
		"SERVICE": "ELEKTRON_DD",
		"underlying_ticker": "AWX",
		"intrinsic_value": "0.000",
		"exercise_price_cal": 4.5,
		"issuer_code": "MBL",
		"REC_STATUS": "0",
		"underlying_name": "AEM HOLDINGS LTD",
		"TURNOVER": "220",
		"PCTCHNG": "-67.7",
		"YRLOW": "-",
		"BEST_ASIZ1": "3000000",
		"ACVOL_1": "20,000",
		"days_to_maturity": "8",
		"ric": "AEML_tk.SI",
		"exercise_price": "4.50"
	},
  "systemtime": "23 Feb 21 16:55",
  D: "09:00;0.000|09:01;0.000|09:02;0.000|09:03;0.000|09:04;0.000|09:05;0.000|09:06;0.000|09:07;0.000|09:08;0.000|09:09;0.000|09:10;0.000|09:11;0.000|09:12;0.000|09:13;0.000|09:14;0.000|09:15;0.000|09:16;0.000|09:17;0.000|09:18;0.000|09:19;0.000|09:20;0.000|09:21;0.000|09:22;0.000|09:23;0.000|09:24;0.000|09:25;0.000|09:26;0.000|09:27;0.000|09:28;0.000|09:29;0.000|09:30;0.000|09:31;4.280|09:31;4.280|09:32;4.280|09:32;4.280|09:33;4.280|09:33;4.280|09:35;4.290|09:35;4.290|09:36;4.290|09:36;4.290|09:37;4.300|09:37;4.300|09:38;4.300|09:38;4.300|09:39;4.300|09:39;4.300|09:40;4.300|09:40;4.300|09:41;4.300|09:41;4.300|09:42;4.300|09:42;4.300|09:43;4.310|09:43;4.310|09:44;4.310|09:44;4.310|09:45;4.310|09:45;4.310|09:46;4.310|09:46;4.310|09:47;4.310|09:47;4.310|09:48;4.310|09:48;4.310|09:50;4.310|09:50;4.310|09:51;4.320|09:51;4.320|09:52;4.320|09:52;4.320|09:53;4.320|09:53;4.320|09:54;4.320|09:54;4.320|09:55;4.320|09:55;4.320|09:56;4.320|09:56;4.320|09:57;4.320|09:57;4.320|09:58;4.320|09:58;4.320|10:00;4.320|10:00;4.320|10:01;4.330|10:01;4.330|10:03;4.330|10:03;4.330|10:04;4.320|10:04;4.320|10:06;4.330|10:06;4.330|10:07;4.330|10:07;4.330|10:08;4.330|10:08;4.330|10:09;4.320|10:09;4.320|10:10;4.320|10:10;4.320|10:12;4.310|10:12;4.310|10:13;4.310|10:13;4.310|10:14;4.310|10:14;4.310|10:16;4.310|10:16;4.310|10:18;4.300|10:18;4.300|10:20;4.310|10:20;4.310|10:21;4.310|10:21;4.310|10:22;4.310|10:22;4.310|10:23;4.310|10:23;4.310|10:24;4.310|10:24;4.310|10:25;4.310|10:25;4.310|10:26;4.310|10:26;4.310|10:27;4.310|10:27;4.310|10:28;4.320|10:28;4.320|10:32;4.320|10:32;4.320|10:33;4.320|10:33;4.320|10:35;4.320|10:35;4.320|10:36;4.310|10:36;4.310|10:37;4.320|10:37;4.320|10:38;4.320|10:38;4.320|10:41;4.320|10:41;4.320|10:42;4.320|10:42;4.320|10:44;4.320|10:44;4.320|10:45;4.320|10:45;4.320|10:46;4.320|10:46;4.320|10:47;4.320|10:47;4.320|10:48;4.320|10:48;4.320|10:50;4.290|10:50;4.290|10:51;4.290|10:51;4.290|10:53;4.290|10:53;4.290|10:54;4.290|10:54;4.290|10:55;4.290|10:55;4.290|10:57;4.290|10:57;4.290|10:58;4.290|10:58;4.290|11:00;4.290|11:00;4.290|11:02;4.290|11:02;4.290|11:03;4.290|11:03;4.290|11:04;4.300|11:04;4.300|11:05;4.290|11:05;4.290|11:07;4.300|11:07;4.300|11:09;4.300|11:09;4.300|11:10;4.300|11:10;4.300|11:11;4.310|11:11;4.310|11:12;4.310|11:12;4.310|11:14;4.310|11:14;4.310|11:15;4.310|11:15;4.310|11:16;4.310|11:16;4.310|11:17;4.310|11:17;4.310|11:18;4.310|11:18;4.310|11:19;4.310|11:19;4.310|11:21;4.310|11:21;4.310|11:22;4.310|11:22;4.310|11:23;4.320|11:23;4.320|11:24;4.310|11:24;4.310|11:25;4.310|11:25;4.310|11:26;4.310|11:26;4.310|11:27;4.310|11:27;4.310|11:28;4.310|11:28;4.310|11:29;4.300|11:29;4.300|11:33;4.310|11:33;4.310|11:35;4.300|11:35;4.300|11:36;4.310|11:36;4.310|11:37;4.300|11:37;4.300|11:39;4.320|11:39;4.320|11:40;4.310|11:40;4.310|11:41;4.320|11:41;4.320|11:43;4.310|11:43;4.310|11:44;4.310|11:44;4.310|11:46;4.310|11:46;4.310|11:47;4.300|11:47;4.300|11:48;4.300|11:48;4.300|11:49;4.300|11:49;4.300|11:50;4.300|11:50;4.300|11:51;4.300|11:51;4.300|11:52;4.300|11:52;4.300|11:53;4.290|11:53;4.290|11:54;4.300|11:54;4.300|11:55;4.300|11:55;4.300|11:56;4.310|11:56;4.310|11:57;4.310|11:57;4.310|11:58;4.310|11:58;4.310|11:59;4.310|11:59;4.310|12:58;4.310|12:58;4.310|13:00;4.320|13:00;4.320|13:02;4.320|13:02;4.320|13:03;4.320|13:03;4.320|13:04;4.320|13:04;4.320|13:05;4.320|13:05;4.320|13:06;4.320|13:06;4.320|13:07;4.310|13:07;4.310|13:10;4.300|13:10;4.300|13:11;4.310|13:11;4.310|13:12;4.310|13:12;4.310|13:13;4.310|13:13;4.310|13:14;4.310|13:14;4.310|13:15;4.320|13:15;4.320|13:16;4.320|13:16;4.320|13:18;4.320|13:18;4.320|13:19;4.320|13:19;4.320|13:20;4.320|13:20;4.320|13:21;4.320|13:21;4.320|13:22;4.320|13:22;4.320|13:23;4.320|13:23;4.320|13:24;4.320|13:24;4.320|13:25;4.320|13:25;4.320|13:26;4.320|13:26;4.320|13:27;4.320|13:27;4.320|13:28;4.320|13:28;4.320|13:29;4.320|13:29;4.320|13:30;4.320|13:30;4.320|13:31;4.320|13:31;4.320|13:32;4.320|13:32;4.320|13:33;4.320|13:33;4.320|13:34;4.320|13:34;4.320|13:35;4.320|13:35;4.320|13:36;4.330|13:36;4.330|13:37;4.330|13:37;4.330|13:38;4.330|13:38;4.330|13:39;4.330|13:39;4.330|13:41;4.330|13:41;4.330|13:42;4.330|13:42;4.330|13:43;4.320|13:43;4.320|13:44;4.320|13:44;4.320|13:45;4.320|13:45;4.320|13:46;4.330|13:46;4.330|13:47;4.330|13:47;4.330|13:48;4.330|13:48;4.330|13:49;4.320|13:49;4.320|13:52;4.310|13:52;4.310|13:53;4.320|13:53;4.320|13:54;4.320|13:54;4.320|13:55;4.320|13:55;4.320|13:56;4.330|13:56;4.330|13:58;4.330|13:58;4.330|13:59;4.320|13:59;4.320|14:00;4.320|14:00;4.320|14:01;4.320|14:01;4.320|14:05;4.310|14:05;4.310|14:07;4.320|14:07;4.320|14:08;4.320|14:08;4.320|14:09;4.320|14:09;4.320|14:11;4.320|14:11;4.320|14:12;4.310|14:12;4.310|14:13;4.320|14:13;4.320|14:14;4.310|14:14;4.310|14:15;4.310|14:15;4.310|14:16;4.320|14:16;4.320|14:17;4.320|14:17;4.320|14:20;4.330|14:20;4.330|14:21;4.330|14:21;4.330|14:22;4.330|14:22;4.330|14:23;4.320|14:23;4.320|14:25;4.320|14:25;4.320|14:27;4.330|14:27;4.330|14:28;4.330|14:28;4.330|14:29;4.330|14:29;4.330|14:31;4.320|14:31;4.320|14:32;4.320|14:32;4.320|14:34;4.320|14:34;4.320|14:36;4.320|14:36;4.320|14:37;4.330|14:37;4.330|14:40;4.330|14:40;4.330|14:41;4.320|14:41;4.320|14:42;4.330|14:42;4.330|14:43;4.320|14:43;4.320|14:44;4.330|14:44;4.330|14:46;4.320|14:46;4.320|14:47;4.320|14:47;4.320|14:49;4.320|14:49;4.320|14:50;4.330|14:50;4.330|14:52;4.320|14:52;4.320|14:53;4.320|14:53;4.320|14:54;4.300|14:54;4.300|14:55;4.290|14:55;4.290|14:56;4.290|14:56;4.290|14:57;4.290|14:57;4.290|14:58;4.290|14:58;4.290|14:59;4.290|14:59;4.290|15:00;4.290|15:00;4.290|15:01;4.290|15:01;4.290|15:02;4.290|15:02;4.290|15:03;4.290|15:03;4.290|15:04;4.300|15:04;4.300|15:05;4.290|15:05;4.290|15:06;4.300|15:06;4.300|15:07;4.300|15:07;4.300|15:08;4.290|15:08;4.290|15:09;4.290|15:09;4.290|15:11;4.300|15:11;4.300|15:13;4.290|15:13;4.290|15:14;4.300|15:14;4.300|15:15;4.300|15:15;4.300|15:16;4.290|15:16;4.290|15:17;4.280|15:17;4.280|15:18;4.280|15:18;4.280|15:19;4.280|15:19;4.280|15:20;4.280|15:20;4.280|15:21;4.280|15:21;4.280|15:22;4.290|15:22;4.290|15:23;4.290|15:23;4.290|15:24;4.290|15:24;4.290|15:25;4.280|15:25;4.280|15:26;4.290|15:26;4.290|15:27;4.290|15:27;4.290|15:28;4.280|15:28;4.280|15:29;4.290|15:29;4.290|15:30;4.280|15:30;4.280|15:31;4.290|15:31;4.290|15:32;4.290|15:32;4.290|15:33;4.290|15:33;4.290|15:34;4.280|15:34;4.280|15:35;4.280|15:35;4.280|15:36;4.290|15:36;4.290|15:37;4.290|15:37;4.290|15:38;4.290|15:38;4.290|15:39;4.280|15:39;4.280|15:40;4.280|15:40;4.280|15:41;4.290|15:41;4.290|15:42;4.290|15:42;4.290|15:43;4.290|15:43;4.290|15:44;4.290|15:44;4.290|15:45;4.280|15:45;4.280|15:46;4.290|15:46;4.290|15:47;4.290|15:47;4.290|15:48;4.290|15:48;4.290|15:49;4.280|15:49;4.280|15:50;4.290|15:50;4.290|15:51;4.290|15:51;4.290|15:52;4.290|15:52;4.290|15:53;4.300|15:53;4.300|15:54;4.300|15:54;4.300|15:55;4.300|15:55;4.300|15:56;4.300|15:56;4.300|15:57;4.290|15:57;4.290|15:58;4.300|15:58;4.300|15:59;4.290|15:59;4.290|16:00;4.300|16:00;4.300|16:01;4.300|16:01;4.300|16:02;4.290|16:02;4.290|16:03;4.300|16:03;4.300|16:04;4.300|16:04;4.300|16:05;4.290|16:05;4.290|16:06;4.290|16:06;4.290|16:07;4.290|16:07;4.290|16:08;4.280|16:08;4.280|16:09;4.290|16:09;4.290|16:10;4.290|16:10;4.290|16:11;4.290|16:11;4.290|16:12;4.290|16:12;4.290|16:13;4.290|16:13;4.290|16:14;4.290|16:14;4.290|16:15;4.280|16:15;4.280|16:16;4.300|16:16;4.300|16:17;4.300|16:17;4.300|16:18;4.300|16:18;4.300|16:19;4.300|16:19;4.300|16:20;4.300|16:20;4.300|16:21;4.300|16:21;4.300|16:22;4.300|16:22;4.300|16:23;4.300|16:23;4.300|16:24;4.300|16:24;4.300|16:25;4.300|16:25;4.300|16:26;4.290|16:26;4.290|16:27;4.290|16:27;4.290|16:28;4.290|16:28;4.290|16:29;4.300|16:29;4.300|16:30;4.300|16:30;4.300|16:31;4.280|16:31;4.280|16:32;4.290|16:32;4.290|16:32;4.290|16:33;4.290|16:33;4.290|16:34;4.290|16:34;4.290|16:35;4.280|16:35;4.280|16:36;4.280|16:36;4.280|16:37;4.280|16:37;4.280|16:38;4.280|16:38;4.280|16:39;4.280|16:39;4.280|16:40;4.280|16:40;4.280|16:41;4.280|16:41;4.280|16:42;4.290|16:42;4.290|16:43;4.290|16:43;4.290|16:44;4.290|16:44;4.290|16:45;4.290|16:45;4.290|16:46;4.290|16:46;4.290|16:47;4.290|16:47;4.290|16:48;4.290|16:48;4.290|16:49;4.290|16:49;4.290|16:50;4.280|16:50;4.280|16:51;4.280|16:51;4.280|16:52;4.280|16:52;4.280|16:53;4.280|16:53;4.280|16:54;4.280|16:54;4.280|16:55;4.280|16:55;4.280|16:56;4.270|16:56;4.270|16:57;4.270|16:57;4.270|16:58;4.280|16:58;4.280|16:59;4.280|16:59;4.280|17:00;4.290=09:00;0.000|09:01;0.000|09:02;0.000|09:03;0.000|09:04;0.000|09:05;0.000|09:06;0.000|09:07;0.000|09:08;0.000|09:09;0.000|09:10;0.000|09:11;0.000|09:12;0.000|09:13;0.000|09:14;0.000|09:15;0.000|09:16;0.000|09:17;0.000|09:18;0.000|09:19;0.000|09:20;0.000|09:21;0.000|09:22;0.000|09:23;0.000|09:24;0.000|09:25;0.000|09:26;0.000|09:27;0.000|09:28;0.000|09:29;0.000|09:30;0.000|09:31;0.002|09:32;0.002|09:33;0.002|09:34;0.002|09:34;0.002|09:35;0.002|09:36;0.002|09:37;0.002|09:38;0.002|09:39;0.002|09:40;0.002|09:41;0.003|09:42;0.002|09:43;0.003|09:44;0.003|09:46;0.003|09:47;0.003|09:48;0.003|09:49;0.003|09:50;0.003|09:51;0.003|09:52;0.003|09:53;0.003|09:54;0.003|09:55;0.003|09:56;0.003|09:57;0.003|09:58;0.003|09:59;0.003|09:59;0.003|10:00;0.003|10:01;0.003|10:02;0.003|10:02;0.003|10:03;0.003|10:04;0.003|10:05;0.003|10:05;0.003|10:06;0.003|10:07;0.003|10:08;0.003|10:09;0.003|10:10;0.003|10:11;0.003|10:11;0.003|10:12;0.003|10:13;0.003|10:15;0.003|10:15;0.003|10:20;0.003|10:21;0.003|10:22;0.003|10:23;0.003|10:24;0.003|10:25;0.003|10:26;0.003|10:27;0.003|10:28;0.003|10:29;0.003|10:29;0.003|10:30;0.003|10:30;0.003|10:32;0.003|10:33;0.003|10:34;0.003|10:34;0.003|10:35;0.003|10:36;0.003|10:37;0.003|10:38;0.003|10:41;0.003|10:42;0.003|10:43;0.003|10:44;0.003|10:45;0.003|10:46;0.003|10:47;0.003|10:48;0.002|10:49;0.002|10:50;0.002|10:51;0.002|10:52;0.002|10:52;0.002|10:53;0.002|10:54;0.002|10:55;0.002|10:56;0.002|10:56;0.002|10:57;0.002|10:58;0.002|11:00;0.002|11:01;0.002|11:01;0.002|11:02;0.002|11:03;0.002|11:04;0.002|11:05;0.002|11:06;0.002|11:06;0.002|11:07;0.002|11:08;0.002|11:08;0.002|11:09;0.002|11:10;0.002|11:11;0.003|11:12;0.003|11:14;0.003|11:15;0.003|11:17;0.003|11:18;0.003|11:19;0.003|11:20;0.003|11:20;0.003|11:21;0.003|11:22;0.003|11:23;0.003|11:24;0.003|11:25;0.003|11:26;0.003|11:27;0.003|11:29;0.003|11:30;0.003|11:30;0.003|11:31;0.003|11:31;0.003|11:33;0.003|11:34;0.003|11:34;0.003|11:35;0.003|11:36;0.003|11:37;0.003|11:38;0.003|11:38;0.003|11:39;0.003|11:40;0.003|11:41;0.003|11:42;0.003|11:42;0.003|11:43;0.003|11:45;0.003|11:45;0.003|11:46;0.003|11:47;0.002|11:48;0.002|11:49;0.002|11:50;0.002|11:51;0.002|11:52;0.002|11:53;0.002|11:54;0.002|11:55;0.003|11:56;0.003|11:57;0.003|11:58;0.003|12:05;0.003|12:06;0.003|12:07;0.003|12:08;0.003|12:09;0.003|12:10;0.003|12:11;0.003|12:12;0.003|12:13;0.003|12:14;0.003|12:15;0.003|12:16;0.003|12:17;0.003|12:18;0.003|12:19;0.003|12:20;0.003|12:21;0.003|12:22;0.003|12:23;0.003|12:24;0.003|12:25;0.003|12:26;0.003|12:27;0.003|12:28;0.003|12:29;0.003|12:30;0.003|12:31;0.003|12:32;0.003|12:33;0.003|12:34;0.003|12:35;0.003|12:36;0.003|12:37;0.003|12:38;0.003|12:39;0.003|12:40;0.003|12:41;0.003|12:42;0.003|12:43;0.003|12:44;0.003|12:45;0.003|12:46;0.003|12:47;0.003|12:48;0.003|12:49;0.003|12:50;0.003|12:51;0.003|12:52;0.003|12:53;0.003|12:54;0.003|12:55;0.003|12:56;0.003|12:57;0.003|12:58;0.003|12:59;0.003|13:00;0.003|13:01;0.003|13:02;0.003|13:03;0.003|13:04;0.003|13:05;0.003|13:06;0.003|13:07;0.003|13:08;0.003|13:08;0.003|13:10;0.003|13:11;0.003|13:12;0.003|13:13;0.003|13:14;0.003|13:15;0.003|13:16;0.003|13:17;0.003|13:17;0.003|13:18;0.003|13:19;0.003|13:20;0.003|13:21;0.003|13:22;0.003|13:23;0.003|13:24;0.003|13:25;0.003|13:26;0.003|13:27;0.003|13:28;0.003|13:29;0.003|13:30;0.003|13:31;0.003|13:32;0.003|13:33;0.003|13:34;0.003|13:35;0.003|13:36;0.003|13:37;0.003|13:38;0.003|13:39;0.003|13:40;0.003|13:40;0.003|13:41;0.003|13:42;0.003|13:43;0.003|13:44;0.003|13:45;0.003|13:46;0.003|13:47;0.003|13:48;0.003|13:49;0.003|13:50;0.003|13:50;0.003|13:51;0.003|13:51;0.003|13:52;0.003|13:53;0.003|13:54;0.003|13:55;0.003|13:56;0.003|13:57;0.003|13:57;0.003|13:58;0.003|13:59;0.003|14:00;0.003|14:01;0.003|14:02;0.003|14:02;0.003|14:05;0.003|14:06;0.003|14:06;0.003|14:07;0.003|14:08;0.003|14:09;0.003|14:11;0.003|14:12;0.003|14:14;0.003|14:15;0.003|14:16;0.003|14:17;0.003|14:18;0.003|14:18;0.003|14:19;0.003|14:19;0.003|14:20;0.003|14:21;0.003|14:22;0.003|14:24;0.003|14:24;0.003|14:25;0.003|14:27;0.003|14:28;0.003|14:29;0.003|14:30;0.003|14:30;0.003|14:31;0.003|14:32;0.003|14:34;0.003|14:35;0.003|14:35;0.003|14:37;0.003|14:38;0.003|14:38;0.003|14:39;0.003|14:39;0.003|14:40;0.003|14:41;0.003|14:42;0.003|14:43;0.003|14:44;0.003|14:45;0.003|14:45;0.003|14:46;0.003|14:47;0.003|14:49;0.003|14:50;0.003|14:51;0.003|14:51;0.003|14:52;0.003|14:53;0.003|14:54;0.003|15:02;0.002|15:03;0.002|15:04;0.002|15:05;0.002|15:06;0.002|15:07;0.002|15:08;0.002|15:09;0.002|15:10;0.002|15:11;0.002|15:12;0.002|15:13;0.002|15:14;0.002|15:15;0.002|15:16;0.002|15:17;0.002|15:18;0.002|15:19;0.002|15:20;0.002|15:21;0.002|15:22;0.002|15:23;0.002|15:24;0.002|15:25;0.002|15:26;0.002|15:27;0.002|15:28;0.002|15:29;0.002|15:30;0.002|15:31;0.002|15:32;0.002|15:33;0.002|15:34;0.002|15:35;0.002|15:36;0.002|15:37;0.002|15:38;0.002|15:39;0.002|15:40;0.002|15:41;0.002|15:42;0.002|15:43;0.002|15:44;0.002|15:45;0.002|15:46;0.002|15:47;0.002|15:48;0.002|15:49;0.002|15:50;0.002|15:51;0.002|15:52;0.002|15:53;0.002|15:54;0.002|15:55;0.002|15:56;0.002|15:57;0.002|15:58;0.002|15:59;0.002|16:00;0.002|16:01;0.002|16:02;0.002|16:03;0.002|16:04;0.002|16:05;0.002|16:06;0.002|16:07;0.002|16:08;0.002|16:09;0.002|16:10;0.002|16:11;0.002|16:12;0.002|16:13;0.002|16:14;0.002|16:15;0.002|16:16;0.002|16:17;0.002|16:18;0.002|16:19;0.002|16:20;0.002|16:21;0.002|16:22;0.002|16:23;0.002|16:24;0.002|16:25;0.002|16:26;0.002|16:27;0.002|16:28;0.002|16:29;0.002|16:30;0.002|16:31;0.002|16:32;0.002|16:32;0.002|16:33;0.002|16:34;0.002|16:35;0.002|16:36;0.002|16:37;0.002|16:39;0.002|16:40;0.002|16:41;0.002|16:42;0.002|16:43;0.002|16:44;0.002|16:45;0.002|16:46;0.002|16:47;0.002|16:48;0.002|16:49;0.002|16:50;0.002|16:51;0.002|16:52;0.002|16:53;0.002|16:54;0.002|16:55;0.002|16:56;0.002|16:57;0.002|16:58;0.002|16:59;0.002|17:00;0.002",
  W: "2021-02-16;2021-02-17;2021-02-18;2021-02-19;2021-02-22;2021-02-23=2021-02-16;4.590|2021-02-17;4.530|2021-02-18;4.430|2021-02-19;4.420|2021-02-22;4.330|2021-02-23;4.280=2021-02-16;0.028|2021-02-17;0.024|2021-02-18;0.018|2021-02-19;0.015|2021-02-22;0.006|2021-02-23;0.002  ",
  M: "2021-01-25;2021-01-26;2021-01-27;2021-01-28;2021-01-29;2021-02-01;2021-02-02;2021-02-03;2021-02-04;2021-02-05;2021-02-08;2021-02-09;2021-02-10;2021-02-11;2021-02-15;2021-02-16;2021-02-17;2021-02-18;2021-02-19;2021-02-22;2021-02-23=2021-01-25;4.200|2021-01-26;4.170|2021-01-27;4.160|2021-01-28;3.980|2021-01-29;3.980|2021-02-01;4.130|2021-02-02;4.350|2021-02-03;4.380|2021-02-04;4.390|2021-02-05;4.290|2021-02-08;4.290|2021-02-09;4.250|2021-02-10;4.180|2021-02-11;4.290|2021-02-15;4.620|2021-02-16;4.590|2021-02-17;4.530|2021-02-18;4.430|2021-02-19;4.420|2021-02-22;4.330|2021-02-23;4.280=2021-01-25;0.030|2021-01-26;0.028|2021-01-27;0.028|2021-01-28;0.020|2021-01-29;0.019|2021-02-01;0.023|2021-02-02;0.031|2021-02-03;0.033|2021-02-04;0.031|2021-02-05;0.026|2021-02-08;0.023|2021-02-09;0.022|2021-02-10;0.017|2021-02-11;0.020|2021-02-15;0.034|2021-02-16;0.028|2021-02-17;0.024|2021-02-18;0.018|2021-02-19;0.015|2021-02-22;0.006|2021-02-23;0.002  ",
  Y: "2020-09-22;2020-09-23;2020-09-24;2020-09-25;2020-09-28;2020-09-29;2020-09-30;2020-10-01;2020-10-02;2020-10-05;2020-10-06;2020-10-07;2020-10-08;2020-10-09;2020-10-12;2020-10-13;2020-10-14;2020-10-15;2020-10-16;2020-10-19;2020-10-20;2020-10-21;2020-10-22;2020-10-23;2020-10-26;2020-10-27;2020-10-28;2020-10-29;2020-10-30;2020-11-02;2020-11-03;2020-11-04;2020-11-05;2020-11-06;2020-11-09;2020-11-10;2020-11-11;2020-11-12;2020-11-13;2020-11-16;2020-11-17;2020-11-18;2020-11-19;2020-11-20;2020-11-23;2020-11-24;2020-11-25;2020-11-26;2020-11-27;2020-11-30;2020-12-01;2020-12-02;2020-12-03;2020-12-04;2020-12-07;2020-12-08;2020-12-09;2020-12-10;2020-12-11;2020-12-14;2020-12-15;2020-12-16;2020-12-17;2020-12-18;2020-12-21;2020-12-22;2020-12-23;2020-12-24;2020-12-28;2020-12-29;2020-12-30;2020-12-31;2021-01-04;2021-01-05;2021-01-06;2021-01-07;2021-01-08;2021-01-11;2021-01-12;2021-01-13;2021-01-14;2021-01-15;2021-01-18;2021-01-19;2021-01-20;2021-01-21;2021-01-22;2021-01-25;2021-01-26;2021-01-27;2021-01-28;2021-01-29;2021-02-01;2021-02-02;2021-02-03;2021-02-04;2021-02-05;2021-02-08;2021-02-09;2021-02-10;2021-02-11;2021-02-15;2021-02-16;2021-02-17;2021-02-18;2021-02-19;2021-02-22;2021-02-23=2020-09-22;3.540|2020-09-23;3.570|2020-09-24;3.510|2020-09-25;3.450|2020-09-28;3.420|2020-09-29;3.620|2020-09-30;3.850|2020-10-01;3.710|2020-10-02;3.550|2020-10-05;3.570|2020-10-06;3.620|2020-10-07;3.700|2020-10-08;3.680|2020-10-09;3.650|2020-10-12;3.670|2020-10-13;3.640|2020-10-14;3.690|2020-10-15;3.580|2020-10-16;3.610|2020-10-19;3.590|2020-10-20;3.610|2020-10-21;3.540|2020-10-22;3.590|2020-10-23;3.470|2020-10-26;3.460|2020-10-27;3.430|2020-10-28;3.380|2020-10-29;3.340|2020-10-30;3.380|2020-11-02;3.340|2020-11-03;3.430|2020-11-04;3.470|2020-11-05;3.530|2020-11-06;3.540|2020-11-09;3.730|2020-11-10;3.510|2020-11-11;3.450|2020-11-12;3.380|2020-11-13;3.450|2020-11-16;3.420|2020-11-17;3.330|2020-11-18;3.330|2020-11-19;3.260|2020-11-20;3.240|2020-11-23;3.370|2020-11-24;3.430|2020-11-25;3.400|2020-11-26;3.510|2020-11-27;3.510|2020-11-30;3.530|2020-12-01;3.600|2020-12-02;3.510|2020-12-03;3.520|2020-12-04;3.550|2020-12-07;3.470|2020-12-08;3.440|2020-12-09;3.420|2020-12-10;3.400|2020-12-11;3.360|2020-12-14;3.420|2020-12-15;3.480|2020-12-16;3.500|2020-12-17;3.480|2020-12-18;3.490|2020-12-21;3.400|2020-12-22;3.370|2020-12-23;3.410|2020-12-24;3.390|2020-12-28;3.370|2020-12-29;3.390|2020-12-30;3.450|2020-12-31;3.450|2021-01-04;3.560|2021-01-05;3.590|2021-01-06;3.580|2021-01-07;3.610|2021-01-08;3.650|2021-01-11;3.670|2021-01-12;3.830|2021-01-13;3.890|2021-01-14;3.890|2021-01-15;3.910|2021-01-18;4.030|2021-01-19;4.010|2021-01-20;4.100|2021-01-21;4.080|2021-01-22;4.150|2021-01-25;4.200|2021-01-26;4.170|2021-01-27;4.160|2021-01-28;3.980|2021-01-29;3.980|2021-02-01;4.130|2021-02-02;4.350|2021-02-03;4.380|2021-02-04;4.390|2021-02-05;4.290|2021-02-08;4.290|2021-02-09;4.250|2021-02-10;4.180|2021-02-11;4.290|2021-02-15;4.620|2021-02-16;4.590|2021-02-17;4.530|2021-02-18;4.430|2021-02-19;4.420|2021-02-22;4.330|2021-02-23;4.280=2020-09-24;0.048|2020-09-25;0.046|2020-09-28;0.044|2020-09-29;0.054|2020-09-30;0.064|2020-10-01;0.057|2020-10-02;0.049|2020-10-05;0.048|2020-10-06;0.051|2020-10-07;0.054|2020-10-08;0.053|2020-10-09;0.051|2020-10-12;0.051|2020-10-13;0.050|2020-10-14;0.052|2020-10-15;0.046|2020-10-16;0.048|2020-10-19;0.045|2020-10-20;0.046|2020-10-21;0.043|2020-10-22;0.045|2020-10-23;0.039|2020-10-26;0.039|2020-10-27;0.037|2020-10-28;0.035|2020-10-29;0.033|2020-10-30;0.034|2020-11-02;0.032|2020-11-03;0.035|2020-11-04;0.036|2020-11-05;0.038|2020-11-06;0.038|2020-11-09;0.045|2020-11-10;0.036|2020-11-11;0.033|2020-11-12;0.030|2020-11-13;0.032|2020-11-16;0.031|2020-11-17;0.028|2020-11-18;0.027|2020-11-19;0.025|2020-11-20;0.024|2020-11-23;0.027|2020-11-24;0.029|2020-11-25;0.027|2020-11-26;0.031|2020-11-27;0.031|2020-11-30;0.031|2020-12-01;0.033|2020-12-02;0.029|2020-12-03;0.029|2020-12-04;0.030|2020-12-07;0.026|2020-12-08;0.025|2020-12-09;0.023|2020-12-10;0.023|2020-12-11;0.021|2020-12-14;0.022|2020-12-15;0.024|2020-12-16;0.024|2020-12-17;0.023|2020-12-18;0.023|2020-12-21;0.019|2020-12-22;0.018|2020-12-23;0.019|2020-12-24;0.018|2020-12-28;0.016|2020-12-29;0.016|2020-12-30;0.018|2020-12-31;0.017|2021-01-04;0.018|2021-01-05;0.019|2021-01-06;0.019|2021-01-07;0.019|2021-01-08;0.020|2021-01-11;0.019|2021-01-12;0.024|2021-01-13;0.026|2021-01-14;0.025|2021-01-15;0.025|2021-01-18;0.028|2021-01-19;0.027|2021-01-20;0.030|2021-01-21;0.029|2021-01-22;0.031|2021-01-25;0.030|2021-01-26;0.028|2021-01-27;0.028|2021-01-28;0.020|2021-01-29;0.019|2021-02-01;0.023|2021-02-02;0.031|2021-02-03;0.033|2021-02-04;0.031|2021-02-05;0.026|2021-02-08;0.023|2021-02-09;0.022|2021-02-10;0.017|2021-02-11;0.020|2021-02-15;0.034|2021-02-16;0.028|2021-02-17;0.024|2021-02-18;0.018|2021-02-19;0.015|2021-02-22;0.006|2021-02-23;0.002"
}

const termData = {
  symbols: symbolsSimple,
  "AEML_tk.SI": AEML_tk,
}

export default termData;
